/**
 * @module store
 */

import { createStore } from 'satcheljs';
import ClientConfiguration, { ClientConfigurationRequestState } from './schema/clientConfiguration';
import ClientConfigurationCache, {
    ClientConfigurationCacheState,
} from './schema/clientConfigurationCache';

/**
 * An initial data for the cache
 */

const initialClientConfigurationCache: ClientConfigurationCache = {
    data: null,
    state: ClientConfigurationCacheState.Empty,
    time: null,
};

/**
 * An initial data for the client configuration
 */

const initialClientConfiguration: ClientConfiguration = {
    cache: initialClientConfigurationCache,
    requestState: ClientConfigurationRequestState.UnResolved,
};

/**
 * A store for Actionable Message client configuration
 */

const store = createStore<ClientConfiguration>(
    'amClientConfigurationStore',
    initialClientConfiguration
)();

export default store;
